module.exports = __webpack_public_path__ + "static/media/icon-plus.cf40090e.svg";